import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../endpoints';

export interface MachineType {
    _id: string;
    designation: string;
    price: number;
    priceType: number;
    crudStatus: number;
    usageCount?: {
        total: number;
        machines: number;
    };
    displayOrder?: number;
    updatedAt?: string;
    createdAt?: string;
}

export interface MachinesTypesResponse {
    message: string;
    data: MachineType[];
}

export interface MachineTypeResponse {
    message: string;
    data: MachineType;
}

export interface GetMachinesTypesQueries {
    active?: boolean;
    withUsage?: boolean;
}

export interface CreateMachineTypeBody {
    designation: string;
    price: number;
    priceType: number;
    crudStatus?: number;
    displayOrder?: number | null;
}

export interface UpdateMachineTypeBody {
    designation?: string;
    price?: number;
    priceType?: number;
    crudStatus?: number;
    displayOrder?: number | null;
}

// GET ALL
export const getAllMachinesTypes = async (queries?: GetMachinesTypesQueries): Promise<MachinesTypesResponse> => {
    try {
        const response: AxiosResponse<MachinesTypesResponse> = await apiClient.get('/machine-types', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred while fetching machine types.');
    }
};

// GET ONE
export const getMachineTypeById = async (id: string): Promise<MachineTypeResponse> => {
    try {
        const response: AxiosResponse<MachineTypeResponse> = await apiClient.get(`/machine-types/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred while fetching machine type.');
    }
};

// CREATE
export const createMachineType = async (data: CreateMachineTypeBody): Promise<MachineTypeResponse> => {
    try {
        const response: AxiosResponse<MachineTypeResponse> = await apiClient.post('/machine-types', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred while creating machine type.');
    }
};

// UPDATE
export const updateMachineType = async (id: string, data: UpdateMachineTypeBody): Promise<MachineTypeResponse> => {
    try {
        const response: AxiosResponse<MachineTypeResponse> = await apiClient.patch(`/machine-types/${id}`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred while updating machine type.');
    }
};
